import { getFirstCharName } from '../utils';
export const getPassengerAbbreviation = (name) => {
    const [lastName, firstName] = name.split(' ');
    return getFirstCharName({ lastName, firstName });
};
